import React from 'react';
import isNil from 'lodash/isNil';
import {
  EligibilityAddress,
} from 'dtos/eligibilityAddress';
import Field from 'views/EMR/components/Eligibility/Overview/Field';

type Props = {
  address?: EligibilityAddress;
  className?: string;
  title?: string;
};

export default function Address({ address, className, title }: Props) {
  const {
    line1,
    line2,
    city,
    state,
    postalCode,
  } = address ?? {};

  return !isNil(address) ? (
    <div className={className}>
      {!isNil(title) && (
        <div className="text-xs font-semibold text-gray-500 mb-2">{title}</div>
      )}
      <div className="flex flex-wrap gap-x-6 gap-y-3">
        <Field label="Line 1" value={line1} />
        <Field label="Line 2" value={line2} />
        <Field label="City" value={city} />
        <Field label="State" value={state} />
        <Field label="Postal code" value={postalCode} />
      </div>
    </div>
  ) : null;
}
